/* eslint-disable no-unused-vars */
enum NotificationType {
  ERROR = 'error',
  WARNING = 'warning',
  GENERIC = 'generic',
  SUCCESS = 'success',
}

export default NotificationType;
